import IconButton from 'components/Buttons/IconButton.index'
import ItemButton from 'components/Buttons/ItemButton/ItemButton.index'
import { useIcon } from 'hooks/useIcon'
import { DrawersContext } from 'providers/DrawersProvider'

import React, { useContext } from 'react'

const buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#FFF',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
}

export const TopbarMobileSlotLeft = () => {
  const drawersContext = useContext(DrawersContext)
  return (
    <>
      <IconButton
        icon={useIcon('IcHamburguerMobile')}
        onClick={() => drawersContext.handleSideMenuLeft({ open: !drawersContext.sideMenuLeftState.open })}
      />
    </>
  )
}
export const TopbarMobileSlotRight = () => {
  return (
    <>
      <IconButton icon={useIcon('IcAudioMobile')} />
    </>
  )
}
export const TopbarTopSlotLeft = () => {
  return (
    <>
      <a
        href="https://www.gjccorp.com.br/"
        title="GJC"
        target="_blank"
        rel="noreferrer"
      >
        <IconButton icon={useIcon("IcOjc")} />
      </a>  
    </>
  )
}
export const TopbarTopSlotRight = () => {
  return (
    <>
      {/* FIXME rm classi */}
      <ItemButton href='https://classi.com.br' value='Classi' {...buttons.topbarTopItemsRight} />
      <ItemButton href='https://daqui.opopular.com.br' value='Jornal Daqui' {...buttons.topbarTopItemsRight} />
      <ItemButton href='https://opopular.com.br/' value='Jornal O Popular' {...buttons.topbarTopItemsRight} />
      <ItemButton href='https://www.jornaldotocantins.com.br' value='Jornal do Tocantins' {...buttons.topbarTopItemsRight} />
    </>
  )
}
export const TopbarDesktopSlotRight = () => {
  return (
    <>
    </>
  )
}
export const TopbarExtraSlotRight = () => {
  return (
    <>
    </>
  )
}
